export default "__VITE_ASSET__CieS5SFa__"